import React, { forwardRef, useState } from 'react';

import { MagnifyingGlassIcon, XCircleIcon } from '@_shared/icons';

import * as S from './SearchBar.style';

const SearchBar = forwardRef(
	(
		{
			onSubmit,
			isSearchData,
			onClear,
			initialKeyword,
		}: {
			onSubmit: React.FormEventHandler<HTMLFormElement>;
			isSearchData: boolean;
			onClear: () => void;
			initialKeyword: string;
		},
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => {
		const [isFocus, setIsFocus] = useState(false);

		return (
			<S.Container onSubmit={onSubmit}>
				<S.Input
					placeholder="제목, 내용, 메모로 검색해 보세요."
					name="search"
					ref={ref}
					defaultValue={initialKeyword}
					onFocus={() => {
						setIsFocus(true);
					}}
					onBlur={() => {
						setTimeout(() => {
							setIsFocus(false);
						}, 100);
					}}
				/>
				<S.SubmitButton>
					{isSearchData && !isFocus ? (
						<S.ClearButtonWrapper
							onClick={() => {
								onClear();
							}}
						>
							<XCircleIcon />
						</S.ClearButtonWrapper>
					) : (
						<MagnifyingGlassIcon />
					)}
				</S.SubmitButton>
			</S.Container>
		);
	},
);
SearchBar.displayName = 'SearchBar';

export { SearchBar };
